/**
 * SeaCloud SDK 核心类型定义
 */

/**
 * SDK 配置选项
 */
export interface SeacloudConfig {
  /** API Service Token - 从环境变量 API_SERVICE_TOKEN 读取或直接传入 */
  apiKey?: string;
  /** 代理服务器基础 URL，默认为 http://localhost:8080 */
  baseUrl?: string;
  /** 自定义 fetch 实现（可选，用于 Node.js < 18 或测试） */
  fetch?: typeof fetch;
  /** 请求超时时间（毫秒），默认 30000 */
  timeout?: number;
  /** X-Project header 值，用于 Agent API 访问标识，默认为 'SeaVerse' */
  xProject?: string;
}

/**
 * 任务状态
 */
export type TaskStatus = 'pending' | 'processing' | 'in_progress' | 'completed' | 'failed';

/**
 * 任务错误信息
 */
export interface TaskError {
  code: string;
  message: string;
  details?: any;
}

/**
 * 任务结果
 */
export interface TaskResult {
  /** 任务 ID */
  id: string;
  /** 创建时间戳 */
  created_at: number;
  /** 任务状态 */
  status: TaskStatus;
  /** 错误信息（如果失败） */
  error?: TaskError | null;
  /** 模型名称 */
  model: string;
  /** 输出结果 */
  output?: Array<{
    content?: Array<{
      type?: string;
      url?: string;
      size?: number;
      jobId?: string;
      [key: string]: any;
    }>;
    [key: string]: any;
  }>;
  /** 其他字段 */
  [key: string]: any;
}

/**
 * 任务轮询选项
 */
export interface PollingOptions {
  /** 轮询间隔（毫秒），默认 3000 */
  intervalMs?: number;
  /** 最大尝试次数，默认 120 */
  maxAttempts?: number;
  /** 进度回调函数 */
  onProgress?: (attempt: number, status: TaskStatus) => void;
}

/**
 * HTTP 响应错误
 */
export class SeacloudError extends Error {
  constructor(
    message: string,
    public statusCode?: number,
    public response?: any,
  ) {
    super(message);
    this.name = 'SeacloudError';
  }
}
